/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResolveReferenceRequest = {
  repositoryId: number;
  ref?: string | null | undefined;
};

/** @internal */
export const ResolveReferenceRequest$inboundSchema: z.ZodType<
  ResolveReferenceRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  repository_id: z.number().int(),
  ref: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "repository_id": "repositoryId",
  });
});
/** @internal */
export type ResolveReferenceRequest$Outbound = {
  repository_id: number;
  ref?: string | null | undefined;
};

/** @internal */
export const ResolveReferenceRequest$outboundSchema: z.ZodType<
  ResolveReferenceRequest$Outbound,
  z.ZodTypeDef,
  ResolveReferenceRequest
> = z.object({
  repositoryId: z.number().int(),
  ref: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    repositoryId: "repository_id",
  });
});

export function resolveReferenceRequestToJSON(
  resolveReferenceRequest: ResolveReferenceRequest,
): string {
  return JSON.stringify(
    ResolveReferenceRequest$outboundSchema.parse(resolveReferenceRequest),
  );
}
export function resolveReferenceRequestFromJSON(
  jsonString: string,
): SafeParseResult<ResolveReferenceRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ResolveReferenceRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResolveReferenceRequest' from JSON`,
  );
}
